import * as XLSX from "xlsx";

const EXCEL_COLUMN_MAP = {
  "Vendor Code": "vendorCode",
  "Vendor Name": "vendorName",
  Brand: "brand",
  "Vendor Type": "vendorType",
  "Vendor Classification": "vendorClassification",
  "Owner Mail ID": "ownerEmail",
  "Owner Contact No": "ownerContactNo",
  "Primary Mail ID": "primaryEmail",
  "Primary Contact": "primaryContact",
};

const normalizeCellValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

const mapExcelRow = (row, index) => {
  const mapped = { isImported: true };

  Object.entries(EXCEL_COLUMN_MAP).forEach(([excelColumn, fieldName]) => {
    mapped[fieldName] = normalizeCellValue(row[excelColumn]);
  });

  if (!mapped.vendorCode) {
    return null;
  }

  mapped.vendorRegistrationId = `import-${index}`;
  return mapped;
};

export const parseBulkInviteExcel = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: "array" });
        const sheetName = workbook.SheetNames[0];

        if (!sheetName) {
          resolve([]);
          return;
        }

        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
        const mappedRows = rows
          .map((row, index) => mapExcelRow(row, index))
          .filter(Boolean);

        resolve(mappedRows);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsArrayBuffer(file);
  });

export const isImportedRow = (row) =>
  Boolean(row?.isImported) ||
  String(row?.vendorRegistrationId || "").startsWith("import-");
